/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, Card, Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { cloneDeep, round, some } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { approveRejectSuggestion, setDuplicateCodeModal, getSelectedGradGroupDataSupplier } from '../../store/SupplierSuggestion.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import ShowGrading from './PomLibraries/ShowGrading';
import DuplicateDeleteModal from '../../../../Components/ModalPopup/DuplicateDeleteModal';
import { checkUpdatedData, shortenandHoverString } from '../../../../Components/helper';
import S3Image from '../../../../Components/Utility/S3Image';

function MeasurementCard({
  suggestionData,
  measurementLibaries,
  devOrderId,
  showGrading,
  approveReject,
  sugestionObj,
  suggestionType,
  updateData,
  updatedSuggestionLibrary,
  approveRejectDisable,
  autoApproved,
}) {
  const [selectedIdPomArray, setSelectedIdPomArray] = useState([]);
  const [selectedIdOtherArray, setSelectedIdOtherArray] = useState([]);
  const [isSelectOtherAll, setSelectOtherAll] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [approveRejectComment, setApproveRejectComment] = useState();
  const [disabledOtherCheckBox, setDisabledOtherCheckBox] = useState(false);
  const dateFormat = 'DD-MM-YYYY, h:mm a';
  const [state, setState] = useState({
    measurementPom: [],
    measurementOther: [],
    pomConvertedData: [],
    specPomConvertedData: [],
    oldPomConvertedData: [],
    oldPomSpecConvertedData: [],
    oldPomIds: [],
    oldSpecPomIds: [],
    manipulatedPomData: [],
    manipulatedSpecPomData: [],
  });

  const {
    measurementOther,
    specPomConvertedData,
    measurementPom,
    pomConvertedData,
    oldPomSpecConvertedData,
    oldPomIds,
    oldSpecPomIds,
    manipulatedPomData,
    manipulatedSpecPomData,
  } = state;

  const dispatch = useDispatch();

  const {
    SupplierSuggestion: { duplicateCodeModal, MeasurementSuggestion },
    UserDetails: { userInfo },
  } = useSelector((selectorState) => selectorState);

  const [oldDataFound, setOldDataFound] = useState(false);
  const [conversationData, setConversationData] = useState({
    conversionType: '',
    fraction: '',
  });

  const sizeRanges = useMemo(() => {
    const sizesArr = [];
    MeasurementSuggestion[0]?.sizeRanges?.forEach((item) => {
      if (measurementLibaries?.sizeRanges?.includes(item)) {
        sizesArr.push(item);
      }
    });
    return sizesArr;
  }, [MeasurementSuggestion]);

  useEffect(() => {
    if (measurementLibaries && ('specPomLibraries' in measurementLibaries || 'pomLibraries' in measurementLibaries)) {
      setState((prevState) => ({
        ...prevState,
        measurementOther: [...measurementLibaries.specPomLibraries],
        measurementPom: [...measurementLibaries.pomLibraries],
      }));
    }
  }, [measurementLibaries]);

  const pendingActionOther = Array?.isArray(manipulatedSpecPomData)
    ? manipulatedSpecPomData?.filter((item) => !['Approved', 'Deleted'].includes(item?.status))
    : [];
  const pendingActionOtherCount = pendingActionOther?.length;
  const suggestedOriginalOther = pendingActionOther?.filter((val) => some(oldPomSpecConvertedData, { code: val?.code }));
  const { t } = useTranslation('common');

  const getOldMeasurementDetail = async () => {
    const [{ _id }] = devOrderId;
    const param = {
      devOrderId: _id,
      gradingGroupId: suggestionData?.gradingGroupId,
      allData: true,
    };
    await dispatch(getSelectedGradGroupDataSupplier(param));
    setOldDataFound(true);
  };

  useEffect(() => {
    getOldMeasurementDetail();
  }, []);

  useEffect(() => {
    setShowConfirmationPopup(approveReject?.status);
    setConfirmAction(approveReject?.action);
  }, [approveReject]);

  useEffect(() => {
    if (selectedIdPomArray.length > 0 || selectedIdOtherArray.length > 0) {
      approveRejectDisable(false);
    } else {
      approveRejectDisable(true);
    }
  }, [selectedIdPomArray]);

  useEffect(() => {
    if (suggestedOriginalOther.length === selectedIdOtherArray.length && suggestedOriginalOther.length > 0) {
      setSelectOtherAll(true);
    }
    if (selectedIdOtherArray.length > 0 || selectedIdPomArray.length > 0) {
      approveRejectDisable(false);
    } else {
      approveRejectDisable(true);
    }
  }, [selectedIdOtherArray]);

  const convertOldPomData = async () => {
    const pomLibraries = MeasurementSuggestion[0]?.pomLibraries;
    const clonedPomLibraries = pomLibraries ? [...pomLibraries] : [];
    setState((prevState) => ({
      ...prevState,
      oldPomConvertedData: clonedPomLibraries,
    }));
  };

  const convertOldSpecPomData = async () => {
    const specPomLibraries = MeasurementSuggestion[0]?.specPomLibraries;
    const clonedSpecLibraries = specPomLibraries ? [...specPomLibraries] : [];
    setState((prevState) => ({
      ...prevState,
      oldPomSpecConvertedData: clonedSpecLibraries,
    }));
  };

  useEffect(() => {
    if (MeasurementSuggestion.length > 0) {
      const data = cloneDeep(MeasurementSuggestion);
      const obj = {
        conversionType: data[0]?.conversionType,
        fraction: data[0]?.fraction,
      };
      setConversationData(obj);
      convertOldPomData();
      convertOldSpecPomData();

      MeasurementSuggestion?.forEach((item) => {
        const oldPomIdsVar = item?.pomLibraries?.map((val) => val?.code);
        const oldSpecPomIdsVar = item?.specPomLibraries?.map((val) => val?.code);

        setState((prevState) => ({
          ...prevState,
          oldPomIds: oldPomIdsVar,
          oldSpecPomIds: oldSpecPomIdsVar,
        }));
      });
    }
  }, [MeasurementSuggestion]);

  const convertPomData = async () => {
    setState((prevState) => ({
      ...prevState,
      pomConvertedData: [...measurementPom],
    }));
  };

  const convertSpecPomData = async () => {
    setState((prevState) => ({
      ...prevState,
      specPomConvertedData: [...measurementOther],
    }));
  };

  useEffect(() => {
    convertPomData();
    convertSpecPomData();
  }, [conversationData, measurementOther.length, measurementPom.length]);

  useEffect(() => {
    if (oldDataFound) {
      const newPom = pomConvertedData?.map((item, i) => {
        const oldData = oldPomIds.includes(item.code);

        if (!oldData && item.status !== 'Approved') {
          return {
            ...item,
            status: 'Deleted',
          };
        }
        return {
          ...item,
        };
      });
      setState((prevState) => ({
        ...prevState,
        manipulatedPomData: [...newPom],
      }));
      const newOther = specPomConvertedData?.map((item, i) => {
        const oldData = oldSpecPomIds.includes(item.code);
        if (!oldData && item.status !== 'Approved') {
          return {
            ...item,
            status: 'Deleted',
          };
        }
        return {
          ...item,
        };
      });

      setState((prevState) => ({
        ...prevState,
        manipulatedSpecPomData: [...newOther],
      }));
    }
  }, [oldPomIds, oldSpecPomIds, pomConvertedData, specPomConvertedData]);

  useEffect(() => {
    const objNewMeasurement = {
      pom: manipulatedPomData,
      other: manipulatedSpecPomData,
    };
    updatedSuggestionLibrary(objNewMeasurement);
  }, [manipulatedPomData, manipulatedSpecPomData]);

  useEffect(() => {
    if (measurementPom.length === 1 && measurementOther.length === 0) {
      setSelectedIdPomArray([
        {
          type: 'pomLibraries',
          code: measurementPom[0].code,
        },
      ]);
    }

    if (measurementPom.length === 0 && measurementOther.length === 1) {
      setSelectedIdOtherArray([
        {
          type: 'specPomLibraries',
          code: measurementOther[0].code,
        },
      ]);
    }
  }, [measurementPom, measurementOther]);

  const onSelectCheckBoxOther = async (e, id) => {
    let selectedItemsOther = [...selectedIdOtherArray];

    if (e.target.checked) {
      setSelectedIdOtherArray([
        ...selectedItemsOther,
        {
          type: 'specPomLibraries',
          code: id,
        },
      ]);
    } else {
      setSelectOtherAll(false);
      selectedItemsOther = selectedItemsOther?.filter((item) => item.code !== id);
      setSelectedIdOtherArray([...selectedItemsOther]);
    }
  };

  const handleSelectAllOther = () => {
    if (isSelectOtherAll) {
      setSelectedIdOtherArray([]);
    } else {
      const selectedItems = [...selectedIdOtherArray];
      suggestedOriginalOther.forEach((item) => {
        const findItems = selectedItems?.filter((val) => val.code === item.code);
        if (findItems.length === 0) {
          selectedItems.push({
            type: 'specPomLibraries',
            code: item.code,
          });
        }
      });
      setSelectedIdOtherArray(selectedItems);
    }
    setSelectOtherAll(!isSelectOtherAll);
  };

  const deleteById = async () => {
    const updatedSugestionObj = { ...sugestionObj }; // Clone the object
    updatedSugestionObj.comment = approveRejectComment;
    updatedSugestionObj.componentId = [...selectedIdPomArray, ...selectedIdOtherArray];
    if (confirmAction === 'Approved') {
      updatedSugestionObj.type = suggestionType;
    }
    const response = await dispatch(approveRejectSuggestion(confirmAction, updatedSugestionObj, t)); // API Action call
    if (response) {
      setShowConfirmationPopup(false);
      updateData();
    }
  };

  const handleCommentChange = (e) => {
    setApproveRejectComment(e.target.value);
  };
  const closeDuplicateDeleteModal = () => {
    dispatch(setDuplicateCodeModal(false, null));
  };

  useEffect(() => {
    let pomtotalPending = 0;
    let pomTotalRejected = 0;
    let pomTotalApproved = 0;
    let pomTotalDeleted = 0;

    let otherTotalPending = 0;
    let otherTotalRejected = 0;
    let otherTotalApproved = 0;
    let otherTotalDeleted = 0;
    const newPom = pomConvertedData?.map((item) => {
      const oldData = oldPomIds.includes(item.code);

      if (!oldData && item.status !== 'Approved') {
        return {
          ...item,
          status: 'Deleted',
        };
      }
      return {
        ...item,
      };
    });

    const newOther = specPomConvertedData?.map((item, i) => {
      const oldData = oldSpecPomIds.includes(item.code);
      if (!oldData && item.status !== 'Approved') {
        return {
          ...item,
          status: 'Deleted',
        };
      }
      return {
        ...item,
      };
    });

    if (newPom.length) {
      pomtotalPending = newPom?.filter((item) => item.status === 'Pending').length;

      pomTotalRejected = newPom?.filter((item) => item.status === 'Rejected').length;

      pomTotalApproved = newPom?.filter((item) => item.status === 'Approved').length;

      pomTotalDeleted = newPom?.filter((item) => item.status === 'Deleted').length;
    }

    if (newOther.length) {
      otherTotalPending = newOther?.filter((item) => item.status === 'Pending').length;

      otherTotalRejected = newOther?.filter((item) => item.status === 'Rejected').length;

      otherTotalApproved = newOther?.filter((item) => item.status === 'Approved').length;

      otherTotalDeleted = newOther?.filter((item) => item.status === 'Deleted').length;
    }

    /// for cad file ///

    if (
      (pomTotalApproved > 0 || pomTotalDeleted > 0 || newPom.length === 1) &&
      pomtotalPending === 1 &&
      pomTotalRejected === 0 &&
      (otherTotalApproved > 0 || otherTotalDeleted > 0 || newOther.length === 1) &&
      otherTotalPending === 0 &&
      otherTotalRejected === 0
    ) {
      const pendingId = newPom
        ?.filter((item) => item.status === 'Pending')
        ?.map((el) => ({
          type: 'pomLibraries',
          code: el.code,
        }));

      setSelectedIdPomArray(pendingId);
    }

    if (
      (pomTotalApproved > 0 || pomTotalDeleted > 0 || newPom.length === 1) &&
      pomtotalPending === 0 &&
      pomTotalRejected === 1 &&
      (otherTotalApproved > 0 || otherTotalDeleted > 0 || newOther.length === 1) &&
      otherTotalPending === 0 &&
      otherTotalRejected === 0
    ) {
      const pendingId = newPom
        ?.filter((item) => item.status === 'Rejected')
        ?.map((el) => ({
          type: 'pomLibraries',
          code: el.code,
        }));

      setSelectedIdPomArray(pendingId);
    }

    /// for other Specifications file ///

    if (
      (otherTotalApproved > 0 || otherTotalDeleted > 0 || newOther.length === 1) &&
      otherTotalPending === 1 &&
      otherTotalRejected === 0 &&
      (pomTotalApproved > 0 || pomTotalDeleted > 0 || newPom.length === 0) &&
      pomtotalPending === 0 &&
      pomTotalRejected === 0
    ) {
      const pendingId = newOther
        ?.filter((item) => item.status === 'Pending')
        ?.map((el) => ({
          type: 'specPomLibraries',
          code: el.code,
        }));

      setSelectOtherAll(true);
      setSelectedIdOtherArray(pendingId);
      setDisabledOtherCheckBox(true);
    }

    if (
      (otherTotalApproved > 0 || otherTotalDeleted > 0 || newOther.length === 1) &&
      otherTotalPending === 0 &&
      otherTotalRejected === 1 &&
      (pomTotalApproved > 0 || pomTotalDeleted > 0 || newPom.length === 0) &&
      pomtotalPending === 0 &&
      pomTotalRejected === 0
    ) {
      const pendingId = newOther
        ?.filter((item) => item.status === 'Rejected')
        ?.map((el) => ({
          type: 'specPomLibraries',
          code: el.code,
        }));

      setSelectOtherAll(true);
      setSelectedIdOtherArray(pendingId);
      setDisabledOtherCheckBox(true);
    }
  }, [measurementPom, measurementOther, pomConvertedData, specPomConvertedData]);

  useEffect(() => {
    return () => {
      setSelectedIdPomArray([]);
      setSelectedIdOtherArray([]);
      setSelectOtherAll(false);
      setDisabledOtherCheckBox(false);
    };
  }, []);

  /**
   * Picks a POM row's stored image reference.
   *
   * POM images are persisted as S3 object keys — `<companyURL>/library/POM/<pomId>/pom_<ts>.<ext>`
   * (pom-and-gradings.service.js) — not as URLs. The previous check required an absolute `https://`
   * value and sent every stored key to the placeholder, so images present in S3 never previewed.
   * S3Image resolves the key to a presigned URL and falls back to the placeholder itself, so an
   * empty string is returned here rather than a hardcoded asset path.
   * @param {object} item - POM row carrying `img` and/or `image`
   * @returns {string} the stored image reference, or '' when the row has none
   */
  const getImageSource = (item) => item?.img || item?.image || '';

  return (
    <div className="collapse-card">
      {measurementOther.length > 0 && (
        <Accordion defaultActiveKey="1">
          <Card className="mb-3 overflow-visible">
            <Card.Header>
              {t('MEASUREMENT_CARD.OTHER_SPECIFICATIONS')}
              <Accordion.Toggle className="btn-toggle" as={Button} variant="link" eventKey="1">
                <i className="icon-add" />
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <div className="table-responsive">
                  <table className="table common-custom-table">
                    <thead>
                      <tr>
                        {userInfo.role !== 'Supplier' && pendingActionOtherCount > 0 && (
                          <th aria-label="check" className="w-80px">
                            <div className="checkbox-label no-label margin-auto">
                              <input
                                type="checkbox"
                                onChange={handleSelectAllOther}
                                name="check_all"
                                id="check_all"
                                disabled={(measurementPom.length === 0 && measurementOther.length === 1) || disabledOtherCheckBox}
                                checked={isSelectOtherAll || (measurementPom.length === 0 && measurementOther.length === 1)}

                                // disabled={allUsers.length > 0 ? false : true}
                              />
                              <label htmlFor="check_all" className="chklabel">
                                <span />
                              </label>
                            </div>
                          </th>
                        )}
                        <th className="w-200px">{t('MEASUREMENT_CARD.ORIGINAL_SUGGESTION')}</th>
                        <th className="w-100px">{t('MEASUREMENT_CARD.IMAGE')}</th>
                        <th className="w-150px">{t('MEASUREMENT_CARD.POM_CODE')}</th>
                        <th className="w-200px">{t('MEASUREMENT_CARD.POM_DESCRIPTION')}</th>
                        {sizeRanges?.map((grading_item) => {
                          return (
                            <th key={grading_item} className="w-120px">
                              {grading_item}
                            </th>
                          );
                        })}
                        <th className="w-100px">{t('MEASUREMENT_CARD.TOL')}</th>
                        <th className="w-120px">{t('MEASUREMENT_CARD.STATUS')}</th>
                      </tr>
                    </thead>
                    {manipulatedSpecPomData.length > 0 &&
                      manipulatedSpecPomData.map((data, i) => {
                        const oldData = oldPomSpecConvertedData?.length > 0 && oldPomSpecConvertedData?.filter((e) => e.code === data.code);

                        let isTolMinus = false;

                        if (oldData.length > 0 && oldData[0]?.tolMinus !== data?.tolMinus) {
                          isTolMinus = true;
                        }
                        return (
                          <tbody key={data._id}>
                            {data.status === 'Approved' ? (
                              <tr>
                                {userInfo.role !== 'Supplier' && pendingActionOther.length > 0 && <td />}
                                <td>{t('MEASUREMENT_CARD.ORIGINAL')}</td>
                                <td className="w-100px">
                                  <S3Image s3Key={getImageSource(data?.originalItem)} width="50" alt="logo" />
                                </td>
                                <td className="w-150px">{data?.originalItem?.code}</td>
                                <td>{data?.originalItem?.description}</td>
                                {data?.originalItem?.gradings &&
                                  data?.originalItem?.gradings
                                    ?.filter((item) => sizeRanges.includes(item.sizeName))
                                    ?.map((gradingItem) => {
                                      return (
                                        <td key={gradingItem.measurment} aria-label="gradingItem" className="w-100px p-0">
                                          <ShowGrading gradingData={gradingItem} conversationData={conversationData} showGrading={showGrading} />
                                        </td>
                                      );
                                    })}
                                <td className="w-100px">
                                  {data?.originalItem?.tolMinus && data?.originalItem?.tolMinus !== 'NaN'
                                    ? round(parseFloat(data?.originalItem?.tolMinus), 2)
                                    : 0}
                                </td>
                                <td aria-label="gradingItem" />
                              </tr>
                            ) : (
                              oldData.length > 0 && (
                                <tr>
                                  {userInfo.role !== 'Supplier' && pendingActionOtherCount > 0 && <td />}
                                  <td>{t('MEASUREMENT_CARD.ORIGINAL')}</td>
                                  <td className="w-100px">
                                    <S3Image s3Key={getImageSource(oldData[0])} width="50" alt="logo" />
                                  </td>
                                  <td className="w-150px">{oldData.length > 0 && oldData[0].code}</td>
                                  <td className="w-300px">{oldData.length > 0 && shortenandHoverString(oldData[0].description, 40)}</td>
                                  {oldData.length > 0 &&
                                    oldData[0].gradings
                                      ?.filter((item) => sizeRanges?.includes(item.sizeName))
                                      ?.map((new_grading_item, i) => {
                                        return (
                                          <td className="w-100px p-0" key={i}>
                                            <ShowGrading gradingData={new_grading_item} conversationData={conversationData} showGrading={showGrading} />
                                          </td>
                                        );
                                      })}
                                  <td className="w-100px">
                                    {oldData[0].tolMinus && oldData[0].tolMinus !== 'NaN' ? round(parseFloat(oldData[0].tolMinus), 2) : 0}
                                  </td>
                                  <td />
                                </tr>
                              )
                            )}
                            <tr>
                              {userInfo.role !== 'Supplier' && pendingActionOtherCount > 0 && (
                                <td>
                                  {oldData?.length > 0 && data.status !== 'Approved' && (
                                    <div className="checkbox-label no-label margin-auto">
                                      <input
                                        onChange={(e) => {
                                          onSelectCheckBoxOther(e, data.code);
                                        }}
                                        name={`checks_other_${i}`}
                                        id={`checks_other_${i}`}
                                        type="checkbox"
                                        checked={
                                          selectedIdOtherArray.some((val) => val.code === data.code) ||
                                          (measurementPom.length === 0 && measurementOther.length === 1)
                                        }
                                        disabled={(measurementPom.length === 0 && measurementOther.length === 1) || disabledOtherCheckBox}
                                      />
                                      <label htmlFor={`checks_other_${i}`} className="chklabel">
                                        <span />
                                      </label>
                                    </div>
                                  )}
                                </td>
                              )}
                              <td>{t('MEASUREMENT_CARD.SUGGESTION')}</td>
                              <td className="w-100px">
                                <S3Image s3Key={getImageSource(data)} width="50" alt="logo" />
                              </td>
                              <td className="w-150px">{data.code}</td>
                              {oldData?.length > 0 && data.status !== 'Approved' ? (
                                checkUpdatedData(data.description, oldData[0]?.description)
                              ) : (
                                <td>{data.description}</td>
                              )}
                              {data?.gradings &&
                                data.gradings
                                  ?.filter((item) => sizeRanges.includes(item.sizeName))
                                  ?.map((grading_item, i) => {
                                    const oldObj = oldData[0]?.gradings.find((o) => o.sizeName === grading_item.sizeName);
                                    let isMeasurementChange = false;
                                    let isGradingChange = false;
                                    if (oldObj?.measurment !== grading_item?.measurment) {
                                      isMeasurementChange = true;
                                    }
                                    if (oldObj?.grading !== grading_item?.grading) {
                                      isGradingChange = true;
                                    }

                                    return (
                                      <td aria-label="gradingItem" className="w-100px p-0" key={i}>
                                        <ShowGrading
                                          gradingData={grading_item}
                                          conversationData={conversationData}
                                          showGrading={showGrading}
                                          isMeasurementChange={isMeasurementChange}
                                          isGradingChange={isGradingChange}
                                          isOldData={oldData.length > 0}
                                          isApproved={data.status !== 'Approved'}
                                        />
                                      </td>
                                    );
                                  })}
                              <td className="w-100px">
                                <div className={data.status !== 'Approved' && isTolMinus && 'suggested-data'}>
                                  {data?.tolMinus && data.tolMinus !== 'NaN' ? round(parseFloat(data.tolMinus), 2) : 0}
                                </div>
                              </td>
                              <td className="position-relative">
                                {data.status === 'Approved' ? (
                                  <>
                                    <span className="col-status right approved" /> {t('MEASUREMENT_CARD.APPROVED')}
                                    <OverlayTrigger
                                      placement="bottom"
                                      trigger="hover"
                                      rootClose
                                      overlay={
                                        <Popover className="custom-popover modified-popover">
                                          <Popover.Content>
                                            <div>
                                              <p className="mb-1">
                                                <strong>
                                                  {autoApproved ? t('BOM.BOM_SUGGESTION_CARD.AUTO_APPROVED_BY') : t('MEASUREMENT_CARD.APPROVED_BY')}&nbsp;
                                                </strong>
                                                {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                                              </p>
                                              <p className="mb-1">
                                                <strong>{t('MEASUREMENT_CARD.APPROVED_AT')}&nbsp;</strong>
                                                {moment(data.approvedRejectedAt).format(dateFormat)}
                                              </p>
                                              <p className="mb-0">
                                                <strong>{t('MEASUREMENT_CARD.COMMENT')}&nbsp;</strong>
                                                {data?.comment}
                                              </p>
                                            </div>
                                          </Popover.Content>
                                        </Popover>
                                      }
                                    >
                                      <i className="icon icon-Information f-20 ml-2" />
                                    </OverlayTrigger>
                                  </>
                                ) : data.status === 'Rejected' ? (
                                  <>
                                    <span className="col-status right rejected" />
                                    {t('MEASUREMENT_CARD.REJECTED')}
                                    <OverlayTrigger
                                      placement="bottom"
                                      trigger="hover"
                                      rootClose
                                      overlay={
                                        <Popover className="custom-popover modified-popover">
                                          <Popover.Content>
                                            <div>
                                              <p className="mb-1">
                                                <b>{t('MEASUREMENT_CARD.REJECTED_BY')}&nbsp;</b>
                                                {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                                              </p>
                                              <p className="mb-1">
                                                <b>{t('MEASUREMENT_CARD.REJECTED_AT')}&nbsp;</b>
                                                {moment(data.approvedRejectedAt).format(dateFormat)}
                                              </p>
                                              <p className="mb-0">
                                                <b>{t('MEASUREMENT_CARD.COMMENT')}&nbsp;</b>
                                                {data?.comment}
                                              </p>
                                            </div>
                                          </Popover.Content>
                                        </Popover>
                                      }
                                    >
                                      <i className="icon icon-Information f-20 ml-2" />
                                    </OverlayTrigger>
                                  </>
                                ) : data.status === 'Deleted' ? (
                                  <>
                                    <span className="col-status right deleted" />
                                    {t('MEASUREMENT_CARD.ORIGINAL_DATA_EXIST')}
                                  </>
                                ) : (
                                  <>
                                    <span className="col-status right pending" />
                                    {t('MEASUREMENT_CARD.PENDING')}
                                  </>
                                )}
                              </td>

                              {/* <td className="position-relative">{renderStatus(data)}</td> */}
                            </tr>
                          </tbody>
                        );
                      })}
                  </table>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={false}
          title={
            confirmAction === 'Approved'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_APPROVE')
              : confirmAction === 'Rejected'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_REJECT')
              : ''
          }
          message={
            confirmAction === 'Approved'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_APPROVE')
              : confirmAction === 'Rejected'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_REJECT')
              : ''
          }
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
          isCommentOn
          commentText={handleCommentChange}
        />
      )}
      {duplicateCodeModal.isOpen && (
        <DuplicateDeleteModal
          onOpen={duplicateCodeModal.isOpen}
          title={t('MEASUREMENT_CARD.ERROR_FILE')}
          toggle={() => closeDuplicateDeleteModal()}
          codeItem={duplicateCodeModal?.code}
        />
      )}
    </div>
  );
}

export default MeasurementCard;
